// extracted by mini-css-extract-plugin
module.exports = {"JobBoardContainer":"JobBoardContainer_JobBoardContainer__1EWzo","FiltersLegendWrapper":"JobBoardContainer_FiltersLegendWrapper__lilIH"};